import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import checked from '../../Assets/Icons/checked.svg'
import unchecked from '../../Assets/Icons/unchecked.svg'
import send from '../../Assets/Icons/send.svg'

import './CommandePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useNavigate} from "react-router-dom";
import BaseInput from "../../Components/BaseInput/BaseInput";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {OrderModel} from "../../Models/OrderModel";
import {setUser} from "../../store/actions";
import axios from "axios";
import Login from "../../Components/Login/login";
import Success from "../../Components/Success/Success";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import {useError} from "../../hooks/useError";
import Error from "../../Components/Error/Error";

const CommandePage: React.FC = ({}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)

    const [createAccount, setCreateAccount] = useState<boolean>(false)
    const [showBtmSheet, setShowBtmSheet] = useState<boolean>(false)
    const [showLogin, setShowLogin] = useState<boolean>(false)
    const [prenom, setPrenom] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [mdp1, setMdp1] = useState<string>('')
    const [mdp2, setMdp2] = useState<string>('')
    const [errorMdp, setErrorMdp] = useState<string | undefined>(undefined)
    const [errorEmail, setErrorEmail] = useState<string | undefined>(undefined)

    const loader = useLoader()
    const error = useError()

    useEffect(() => {
        if(mdp1.length > 0 && mdp1.length < 8) {
            setErrorMdp('Votre mot de passe doit contenir 8 caractères minimum')
        } else if (mdp2.length > 0 && mdp1 !== mdp2) {
            setErrorMdp('les mots de passe de correpondent pas')
        } else {
            setErrorMdp(undefined)
        }
    }, [mdp1, mdp2])

    useEffect(() => {
        setErrorEmail(undefined)
    }, [email])

    const handleBtnClick = () => {
        const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
        if(regex.test(email)) {
            if (createAccount) {
                if (mdp1.length < 8) {
                    setErrorMdp('Votre mot de passe doit contenir 8 caractères minimum')
                } else if (mdp1 !== mdp2) {
                    setErrorMdp('les mots de passe de correpondent pas')
                } else {
                    loader.show()
                    axios.post(`${process.env.REACT_APP_BART_URL}/users/create`, {prenom, email, mdp: mdp1})
                        .then(res => {
                            dispatch(setUser(res.data))
                            setShowBtmSheet(true)
                        })
                        .catch(err => {
                            if (err.response.status === 400) {
                                error.open(err.response.data.message)
                            } else {
                                error.open("une erreur est survenue, merci de contacter le sav")
                            }
                        })
                        .finally(loader.hide)
                }
            } else {
                dispatch(setUser({prenom, email, cartesBancaires: []}))
                navigate('/paiement')
            }
        } else {
            setErrorEmail("Merci de rentrer un email valide.")
        }
    }

    const handleLoginBtn = () => {
        setShowLogin(true)
    }

    return (
        <BasePage showBack title="Votre commande">
            <div className="commande">
                <p className="commande--text">Nous avons besoin de quelques informations pour que la commande se passe bien</p>
                <BaseInput title={"Prénom"} onChange={setPrenom} value={prenom} className="commande--input" />
                <BaseInput title={"Email"} type={"email"} onChange={setEmail} value={email} className="commande--input" errorTxt={errorEmail} />
                <div className="commande__dejaInscrit">
                    <p className="commande__dejaInscrit--title">Déjà inscrit ?</p>
                    <BaseButton className="commande__dejaInscrit--btn" onClick={handleLoginBtn} text="Se connecter" type="outline" />
                </div>
                <div className="commande__checkbox">
                    <img src={createAccount ? checked : unchecked} onClick={() => setCreateAccount(!createAccount)}/>
                    <p className="commande__checkbox--txt">Je souhaite créer un compte pour mes prochaines commandes</p>
                </div>
                {
                    createAccount && (
                        <>
                            <BaseInput
                                title={"Mot de passe"}
                                helpTxt={"Votre mot de passe doit contenir 8 caractères minimum"}
                                onChange={setMdp1}
                                value={mdp1}
                                type={"password"}
                                className="commande--input"
                            />
                            <BaseInput
                                title={"Confirmation du mot de passe"}
                                onChange={setMdp2}
                                value={mdp2}
                                type={"password"}
                                className="commande--input"
                                errorTxt={errorMdp}
                            />
                        </>
                    )
                }
            </div>
            <div className="commandeFooter">
                <div className="commandeFooter__infos">
                    <p className="commandeFooter__infos--total">Total</p>
                    <p className="commandeFooter__infos--totalTxt">{panier?.totalPriceTTC} €</p>
                </div>
                <BaseButton disabled={!email || !prenom} onClick={handleBtnClick} text="Paiement" className="commandeFooter--btn"/>
            </div>
            <Success show={showBtmSheet}
                     close={() => navigate('/paiement')}
                     title="Votre compte a été crée"
                     icone={send}
            />
            <Error show={error.visible} close={error.close} title="Une erreur est survenue" subTitle={error.message || ""} />
            <Login onValidate={() => navigate('/paiement')} show={showLogin} onClose={() => setShowLogin(false)} />
            <Loader visible={loader.visible} />
        </BasePage>
    )
}

export default CommandePage;
